import { hotels } from '../../../config/affiliates/hotels/trip/phuket';
import { Content } from '../../types';

const phuketFamilyHotelsContent: Content = {
  title: 'מלונות מומלצים למשפחות בפוקט',
  imageUrl:
    '/images/thailand/phuket-family-hotels/phuket-family-hotels-wide.jpg',
  introduction:
    'פוקט, האי הגדול בתאילנד, הוא אחד היעדים האהובים ביותר על משפחות ישראליות ובצדק רב. שילוב של חופים עוצרי נשימה, פעילויות מגוונות ואינספור מלונות ידידותיים למשפחות הופכים אותו לגן עדן אמיתי. כדי לעשות לכם סדר ולעזור בבחירת המלון המושלם, ריכזנו עבורכם את ההמלצות הכי חמות, בהתאם לאזורי הלינה המרכזיים באי.',
  sections: [
    {
      title: 'פטונג - חופשה שקטה ליד מרכז העניינים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Marriott Resort & Spa Merlin Beach',
          text: "מחפשים מקום שקט אך גם קרוב להכל? מלון מריוט מרלין ביץ' ייתן לכם את המענה המדוייק. המלון ממוקם בקרבת האזור התוסס של חוף פטונג, אבל מציע שקט ושלווה עם חוף ים פרטי, שלוש בריכות ענקיות, מועדון ילדים פעיל וחדרי משפחה מרווחים. מושלם למעוניינים בשילוב שבין מנוחה ופעילויות מחוץ למלון ובלי להתרחק מהאזור התוסס.",
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> למלון שאטלים חינמיים מספר פעמים ביום למרכז חוף פטונג, הלוך וחזור. מומלץ לשריין מקום מראש!',
          link: {
            url: hotels['marriott-merlin'],
            text: 'לחצו כאן ובדקו את Marriott Merlin Beach בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'קמאלה - מושלם לילדים הקטנים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Sunwing Kamala Beach Resort',
          text: 'אם אתם עם ילדים קטנים, סאנווינג קמאלה הוא בחירה מעולה. המלון ממוקם על חוף רגוע ומציע שלל מתקנים המותאמים עבור משפחות: בריכות רדודות, מגלשות מים קטנות, חדרי משחקים ופעילויות בידור יומיות. בנוסף, מסעדות המלון מציעות תפריטים מיוחדים לילדים. חוויה בטוחה, רגועה וכיפית לכל המשפחה.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> במרחק הליכה קצר מהמלון נמצאים דוכני אוכל ומזכרות רבים, שוק הלילה של קמאלה ופארק השעשועים Carnival Magic.',
          link: {
            url: hotels['sunwing-kamala'],
            text: 'לחצו כאן ובדקו את Sunwing Kamala Beach Resort בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'קאטה - גן עדן למשפחות שאוהבות חופים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Katathani Phuket Beach Resort',
          text: 'חולמים על חופשה כשמולכם חוף מהמם? מלון קטאנטאני מחכה לכם על קו המים של חוף קטה נוי. כאן תמצאו מספר בריכות, מועדון ילדים מושקע, אזורי משחקים, חדרים משפחתיים נוחים ושלל פעילויות ימיות. זהו המקום למעוניינים בחופשה רגועה ובמיקום מושלם.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong>  למלון שני אגפים- האגף החדש "Thani wing" ובו חדרים שעברו שיפוץ והאגף הישן ״Bhuri wing" אשר נמצא קרוב לבריכות ומועדון הילדים. לשיקולכם!',
          link: {
            url: hotels['katathani'],
            text: 'לחצו כאן ובדקו את Katathani Phuket Beach Resort בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'OZO Phuket',
          text: 'למחפשים אווירה קצת יותר מודרנית וקלילה, מלון אוזו פוקט מציע חוויית אירוח מעוצבת ועדכנית. עם חדרים מודרניים למשפחות, בריכת שחייה גדולה ובה מתחם לילדים, מועדון ילדים פעיל ומרחק קצרצר מהחוף ומשוק הלילה, זהו המלון למשפחות צעירות המעוניינות להיות בלב העניינים.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> החדרים יחסית קטנים כך שלמשפחה עם מספר ילדים מומלץ לקחת חדר משפחה עם דלת מקשרת.',
          link: {
            url: hotels['ozo-phuket'],
            text: 'לחצו כאן ובדקו את OZO Phuket בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'קארון',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Emerald Resort Karon - נופש משפחתי רגוע בלב קארון',
          text: 'מלון אמרלד בחוף קארון (Emerald Resort Karon) הוא בחירה מצויינת עבור משפחות המחפשות מיקום מרכזי אך שקט. המלון ממוקם במרחק הליכה קצר מהחוף ובסביבתו שפע מסעדות, חנויות ושווקים מקומיים. החדרים מרווחים ונקיים וישנם גם חדרים משפחתיים עם דלת מקשרת. בריכת השחייה גדולה, עם אזור רדוד לילדים ואף קיים מועדון ילדים קטן עם פעילויות בשעות היום. השירות במקום חמים ואדיב והמחיר משתלם מאוד ביחס לתמורה. מדובר באופציה נהדרת עבור משפחות המעדיפות את האווירה הנינוחה של קארון על פני ההמולה של פטונג.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> במחירים כאלה משתלם מאוד לשדרג לחדר עם גישה לבריכה.',
          link: {
            url: hotels['emerald-karon'],
            text: 'לחצו כאן ובדקו את Emerald Resort Karon בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'לגונה - חופשה יוקרתית ורגועה',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Angsana Laguna Phuket',
          text: 'רוצים להרגיש שאתם על אי פרטי משלכם? במלון אנגסנה לגונה תחוו יוקרה אמיתית באווירה נינוחה. המלון כולל בריכות מרהיבות, מועדון ילדים מצוין, שלל פעילויות ספורט ימי וחדרים מרווחים - כל מה שצריך כדי ליהנות מחופשה מפנקת באמת.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> מלונות הלגונה עובדים בשיתוף פעולה זה עם זה, ומתאפשרת כניסה חינמית למתקני המלונות השונים.',
          link: {
            url: hotels['angsana-laguna'],
            text: 'לחצו כאן ובדקו את Angsana Laguna Phuket בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'מאי קאו - שלווה על קו המים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Marriott Mai Khao Beach',
          text: 'אם חלמתם על חופשה שקטה מול חוף פראי, מלון מריוט מאי קאו הוא המקום עבורכם. כאן תמצאו בריכות גדולות, מתחמי משחק לילדים, מועדון ילדים עשיר וחדרים משפחתיים רחבי ידיים - כל מה שצריך כדי להירגע ולהתמלא באנרגיות.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> למלון שאטל חינמי מספר פעמים בשעה למרכז הקניות הסמוך.',
          link: {
            url: hotels['marriott-mai-khao'],
            text: 'לחצו כאן ובדקו את Marriott Mai Khao Beach בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Anantara Vacation Club',
          text: 'למחפשים חופשה עוד יותר יוקרתית, מלון Anantara Vacation Club מציע סוויטות ווילות מרווחות עם בריכות פרטיות, מועדון ילדים פעיל ומגוון פעילויות לכל המשפחה. אידיאלי למחפשים פרטיות, שקט וטבע, בלי להתפשר על רמת הפינוק.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> המלון ממוקם בקרבת שדה התעופה של פוקט, כך שהינו מושלם עבור יומיים ראשונים לאחר נחיתה עם ילדים.',
          link: {
            url: hotels['anantara-vacation-club'],
            text: 'לחצו כאן ובדקו את Anantara Vacation Club בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'לסיכום',
      type: 'text',
      content:
        'בין אם אתם מעוניינים בחופשה שקטה, פעילה, יוקרתית או קלילה - בפוקט תמצאו בדיוק את ההתאמות הנדרשות עבורכם ועבור משפחותיכם.<br /> כל שנותר הוא לבחור את האזור שהכי מדבר אליכם, לארוז בגדי ים ולהתכונן לחופשה משפחתית בלתי נשכחת!<br /> <strong>נשמח לסייע לכם במציאת המלון המושלם בהתאם לצרכים האישיים שלכם, פנו אלינו באמצעות עמוד צור קשר.</strong>',
      sectionLink: {
        url: '/contact',
        text: 'צור קשר לקבלת סיוע בבחירת המלון המושלם',
      },
    },
  ],
};

export default phuketFamilyHotelsContent;
